import { DittoLogo } from '@dittolive/anvil'
import { PageHeader } from '@portal/core/components/page-header/PageHeader'
import { useEffect } from 'react'
import { captureMessageWithContext } from 'utils/sentry/tracking'

/** Scene shown to users that load the portal with an unsupported browser. */
export default function UnsupportedBrowserScene() {
  useEffect(() => {
    captureMessageWithContext('browser.unsupported', {
      component: 'UnsupportedBrowserScene',
    })
  }, [])

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center space-y-4 p-8">
      <DittoLogo className="block h-20 w-auto" />

      <PageHeader
        title="Sorry! We don't support your browser."
        description="Please switch over to another browser or update your browser in order to access the portal."
        className="justify-center text-center"
      />
    </div>
  )
}
